import { StylesConfig } from 'react-select';

import { plum } from '@/styles/colors';

import { LabelAndValue } from '@/types/custom';

export const selectStyles: StylesConfig<LabelAndValue, true> = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#f5f5f5' : 'white',
    borderColor: isDisabled ? '#d1d5db' : isFocused ? plum[6] : plum[3],
    '&:hover': {
      borderColor: isDisabled ? '#d1d5db' : plum[5]
    },
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    borderRadius: 10,
    minHeight: 35,
    opacity: isDisabled ? 0.6 : 1
  }),
  valueContainer: (provided, { isDisabled }) => ({
    ...provided,
    minHeight: '30px',
    padding: '0 6px',
    fontSize: '12px',
    color: isDisabled ? '#9ca3af' : 'inherit'
  }),
  indicatorsContainer: (provided, { isDisabled }) => ({
    ...provided,
    height: '30px',
    opacity: isDisabled ? 0.5 : 1
  }),
  input: (provided, { isDisabled }) => ({
    ...provided,
    margin: '0px',
    color: isDisabled ? '#9ca3af' : 'inherit'
  }),
  option: (styles, { isSelected, isFocused, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? 'transparent'
      : isSelected
        ? plum[5]
        : isFocused
          ? plum[2]
          : 'transparent',
    color: isDisabled ? '#9ca3af' : isSelected ? 'white' : plum[8],
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    padding: '8px 12px',
    fontSize: '12px',
    opacity: isDisabled ? 0.5 : 1,
    '&:hover': {
      backgroundColor: isDisabled ? 'transparent' : isSelected ? plum[6] : plum[2]
    },
    borderBottom: `1px solid ${plum[3]}`,
    ':last-child': {
      borderBottom: 'none'
    }
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: 10,
    border: `1px solid ${plum[4]}`,
    padding: 0,
    overflow: 'hidden'
  }),
  menuList: (styles) => ({
    ...styles,
    padding: 0,
    maxHeight: '200px'
  }),
  multiValue: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? '#e5e7eb' : plum[2],
    opacity: isDisabled ? 0.6 : 1
  }),
  multiValueLabel: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#9ca3af' : plum[7]
  }),
  multiValueRemove: (styles, { isDisabled }) => ({
    ...styles,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.5 : 1,
    '&:hover': {
      backgroundColor: isDisabled ? 'transparent' : plum[3],
      color: isDisabled ? '#9ca3af' : plum[8]
    }
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#9ca3af' : 'inherit'
  }),
  placeholder: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#d1d5db' : '#9ca3af'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (styles, { isDisabled }) => ({
    ...styles,
    padding: '8px',
    color: isDisabled ? '#d1d5db' : 'inherit',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    '& svg': {
      width: '8px',
      height: '8px'
    },
    '&:hover': {
      color: isDisabled ? '#d1d5db' : 'inherit'
    }
  }),
  clearIndicator: (styles) => ({
    ...styles,
    cursor: 'pointer'
  })
};
